import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { APP_LABELS } from '@config/app-config';
import CustomModal from '@utilities/CustomModal';

import Wages from './wages';
import TotalStaff from './total-staff';

const CampStaffTab = props => {
  const { setLoader, status } = props;

  const [currentTab, setCurrentTab] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [lastActiveTab, setLastActiveTab] = useState('');
  const [activeTab, setActiveTab] = useState('Total Staff');

  const onActive = value => {
    if (value !== activeTab && sessionStorage.getItem('dirty') === 'true') {
      setShowPopup(true);
    } else {
      setActiveTab(value);
    }
    setCurrentTab(value);
    setLastActiveTab(activeTab);
  };

  const handleOk = () => {
    setActiveTab(currentTab);
    setShowPopup(false);
  };

  const handleCancel = () => {
    const activetab = lastActiveTab;
    document.getElementById(activetab).click();
    setActiveTab(activetab);
    setShowPopup(false);
  };

  return (
    <>
      <div className="ymca-completeBox">
        <div className="ymca-directorInfo ymca-globalMetrics">
          <ul className="nav nav-tabs ymca-navTabs" id="myTab">
            <li className="nav-item ymca-navItems">
              <button
                className="nav-link ymca-navLinks active"
                id="Total Staff"
                data-bs-toggle="tab"
                data-bs-target="#totalStaff"
                type="button"
                role="tab"
                aria-controls="totalStaff"
                aria-selected="true"
                onClick={() => {
                  onActive('Total Staff');
                }}
              >
                Total Staff
              </button>
            </li>
            <li className="nav-item ymca-navItems">
              <button
                className="nav-link ymca-navLinks"
                id="Wages"
                data-bs-toggle="tab"
                data-bs-target="#wages"
                type="button"
                role="tab"
                aria-controls="wages"
                aria-selected="false"
                onClick={() => {
                  onActive('Wages');
                }}
              >
                Wages
              </button>
            </li>
          </ul>
          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane ymca-tabPane fade show active"
              id="totalStaff"
              role="tabpanel"
              aria-labelledby="Total Staff"
            >
              {activeTab === 'Total Staff' && (
                <TotalStaff setLoader={setLoader} status={status} />
              )}
            </div>
            <div
              className="tab-pane ymca-tabPaneInner fade"
              id="wages"
              role="tabpanel"
              aria-labelledby="Wages"
            >
              {activeTab === 'Wages' && (
                <Wages setLoader={setLoader} status={status} />
              )}
            </div>
          </div>
        </div>
      </div>

      <CustomModal
        show={showPopup}
        type={APP_LABELS.WARNING}
        message="You have some unsaved changes. If you leave before saving, your
                changes will be lost."
        submitButtonName="Ok"
        onSubmit={handleOk}
        cancelButtonName="Cancel"
        onCancel={handleCancel}
      />
    </>
  );
};

CampStaffTab.propTypes = {
  setLoader: PropTypes.func.isRequired,
  status: PropTypes.objectOf(PropTypes.any).isRequired
};

export default CampStaffTab;
